import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import _ from 'lodash';
import { deleteEvent } from 'gqlQueries/priceSimulator';
import { sendNotification } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

function useDeleteScenarioEvent({ onComplete }: { onComplete: Function }) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);

    const [deleteScenarioEvent] = useMutation(deleteEvent, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            onComplete();
            sendNotification('success', 'Scenario deleted successfully');
        } catch (error) {
            console.error(errorMessage, error);
            sendNotification('error', 'Scenario failed to delete. Please try again.');
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        deleteScenarioEvent: (variables: any) => {
            setError(null);
            setLoading(true);
            deleteScenarioEvent(variables);
        },
    };
}

export { useDeleteScenarioEvent };
